/**
 * Renders one CMS HTML fragment (intro, section body, author bio) in the
 * article prose style (`.article-html` in app/globals.css). The HTML is
 * sanitised at build time in scripts/blog/normalize.mjs.
 */
export default function ArticleHtml({ html, className = "" }: { html: string; className?: string }) {
  return <div className={`article-html ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
